import { useContext } from 'react';

import {
  ScalingContext,
  ScalingContextContext,
} from '../providers/ScalingContextProvider';

export const useGetScalingContext = (): ScalingContext =>
  useContext(ScalingContextContext);
